import { Controller } from "stimulus"
import { Tooltip } from "../lib/tooltip"

export default class extends Controller {
  initialize() {
    Tooltip.install(this.element)
  }
}
